var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgMailFilled = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24998 3.25C2.59312 3.25 1.24998 4.59315 1.24998 6.25V17.75C1.24998 19.4069 2.59312 20.75 4.24998 20.75H19.75C21.4068 20.75 22.75 19.4069 22.75 17.75V7.14498L22.75 7.14496V6.24995C22.75 5.99301 22.7177 5.74362 22.6569 5.50561C22.6569 5.50561 22.6569 5.50561 22.6569 5.50561C22.3258 4.20884 21.1499 3.25 19.75 3.25H4.24998ZM22.6569 5.50561C22.5475 5.51922 22.4394 5.55726 22.3407 5.62148L12 12.355L1.65925 5.62148C1.56062 5.55726 1.4525 5.51921 1.34307 5.5056C1.2823 5.74362 1.25 5.99301 1.25 6.24995V7.14497L11.5907 13.8785C11.8395 14.0405 12.1605 14.0405 12.4093 13.8785L22.75 7.14498V6.25C22.75 5.99304 22.7177 5.74364 22.6569 5.50561Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgMailFilled;